export default __webpack_public_path__ + "b664ebcd6ddcb215d930befa57317bfc.png";